import { Anchor, Text } from '@mantine/core';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { AuditLogType } from '@portals/types';

interface CreateUserProps {
  auditLog: AuditLogType;
}

export const CreateUser: FC<CreateUserProps> = ({ auditLog }) => (
  <Text size="sm">
    Created {auditLog?.params[0]?.model}:{' '}
    <Anchor size="sm" component={Link} to="/settings/users_and_groups/users">
      {auditLog?.params[0]?.display_name}
    </Anchor>
    {auditLog?.params[1]?.name === 'tenant'
      ? ` (org: ${auditLog?.params[1]?.display_name})`
      : null}
  </Text>
);
